import clsx from 'clsx';
import { MouseEventHandler } from 'react';
import { createPortal } from 'react-dom';
import styles from './Alert.module.css';
import { LFC } from '../../types';

export interface AlertProps {
  className?: string;
  open?: boolean;
  onClose?: () => void;
}

const stopPropagation: MouseEventHandler = (e) => e.stopPropagation();

export const Alert: LFC<AlertProps> = ({
  children,
  className,
  open,
  onClose,
}) => {
  return createPortal(
    <div
      className={clsx(styles.backdrop, { [styles.open]: open })}
      onClick={onClose}
      data-testid="backdrop"
    >
      <div onClick={stopPropagation} className={clsx(styles.alert, className)}>
        {children}
      </div>
    </div>,
    document.getElementById('root')!
  );
};
